import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const hasPrerenderedContent = container.innerHTML.trim().length > 0;

if (hasPrerenderedContent) {
  ReactDOM.hydrateRoot(container, <React.StrictMode><App /></React.StrictMode>);
} else {
  const root = ReactDOM.createRoot(container);
  root.render(<React.StrictMode><App /></React.StrictMode>);
}

reportWebVitals();
